import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { IS_LOGGED_IN } from '../shared/constants';

@Injectable({
    providedIn: 'root',
})
export class LoginGuard implements CanActivate {
    constructor(private router: Router, private cookieService: CookieService) {}
    canActivate(): boolean {
        try {
            JSON.parse(this.cookieService.get(IS_LOGGED_IN));
            this.router.navigateByUrl('/account');
            return false;
        } catch {
            return true;
        }
    }
}
